module.exports = __webpack_public_path__ + "static/img/shoonya_icon-png.24bffce.png";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/shoonya_icon-png.png
// module id = sETM
// module chunks = 3